export const conditionTypes = {
  GENERAL: 'General',
  DIRECT_DEBIT: 'DirectDebit',
  CONCESSION: 'Concession',
  MOVE_IN: 'MoveIn'
};
